$(document).ready(function () {
    $(".indrvwMain .rvw_items .item").each(function (s) {
        var e = (s % 2) + 1;
        $(this).addClass("rvw_items-item-coun-" + e);
    }),
        $(".indrvwMain .rvw_items .rvw_items-item-coun-1").wrapAll('<div class="rvw_item_wrap rvw_item_wrap-1"></div>'),
        $(".indrvwMain .rvw_items .rvw_items-item-coun-2").wrapAll('<div class="rvw_item_wrap rvw_item_wrap-2"></div>'),
        $(document).on("click", ".filt-btn", function () {
            $("body").addClass("desk-filter-open");
        }),
        $(document).on("click", ".facets-close-btnn", function () {
            $("body").removeClass("desk-filter-open");
        }),
        $(document).on("click", ".facets-wrapper-overlay", function () {
            $("body").removeClass("desk-filter-open");
        }),
        $(".slider-for").slick({ slidesToShow: 1, slidesToScroll: 1, arrows: !1, fade: !0, swipe: !1, draggable: !0, touchMove: !0, asNavFor: ".slider-nav" }),
        $(".slider-nav").slick({ slidesToShow: 4, slidesToScroll: 1, vertical: !0, asNavFor: ".slider-for", dots: !1, arrows: !1, focusOnSelect: !0, verticalSwiping: !0, responsive: [{ breakpoint: 992, settings: { slidesToShow: 2 } }] }),
        $(window).innerWidth() <= 1199 &&
            ($(".index2Slider").slick({ 
                dots: !1,
                infinite: !1,
                speed: 800,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: !1,
                dots: !0,
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 4, autoplay: true, autoplaySpeed: 4500, infinite: true } },
                    { breakpoint: 640, settings: { slidesToShow: 3, slidesToScroll: 3, autoplay: true, autoplaySpeed: 4500, infinite: true } },
                ],
            }),
            $(".indrvwMain .rvw_items .rvw_items-item-coun-1").unwrap(),
            $(".indrvwMain .rvw_items .rvw_items-item-coun-2").unwrap(),
            $(".indrvwItmSlider").slick({ dots: !1, infinite: !1, speed: 800, slidesToShow: 1, slidesToScroll: 1, arrows: !1, responsive: [{ breakpoint: 640, settings: { slidesToShow: 1 } }] }),
            $(".indx4Slider").slick({
                dots: !1,
                infinite: !1,
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                responsive: [
                    { breakpoint: 989, settings: { slidesToShow: 1 } },
                    { breakpoint: 640, settings: { slidesToShow: 2 } },
                  // {
                  //   breakpoint:749,
                  //   settings:"unslick",
                  // },
                ],
            }),
            $(".insta-items-slider").slick({
                dots: !1,
                infinite: !1,
                speed: 800,
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: !1,
                rows: 2,
                responsive: [
                    { breakpoint: 989, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                    { breakpoint: 640, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                ],
            }));
});
//# sourceMappingURL=/s/files/1/0460/4284/1255/t/39/assets/custom-script.js.map?v=1676873145
